import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { IDayOfWeekList } from '../../../Pages/Pricing/IPricing';

interface IUpdate extends IReduxState<IDayOfWeekList> {
  updateableDate?: IDayOfWeekList;
}

export const UpdateDayOfWeekSlicer = createSlice({
  name: 'UpdateDayOfWeek',
  initialState: {
    data: {},
    isLoading: false,
    updateableDate: {},
  } as IUpdate,
  reducers: {
    updateDayOfWeek: (state, _) => {
      state.isLoading = true;
    },
    successUpdateDayOfWeek: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureUpdateDayOfWeek: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    DayOfWeekUpdateableData: (state, action) => {
      state.updateableDate = action.payload;
    },
    clearUpdateDayOfWeekState: (state) => {
      state.data = {};
      state.updateableDate = undefined;
    },
    clearUpdateableData: (state) => {
      state.updateableDate = undefined;
    },
  },
});

export const {
  updateDayOfWeek,
  failureUpdateDayOfWeek,
  successUpdateDayOfWeek,
  DayOfWeekUpdateableData,
  clearUpdateDayOfWeekState,
  clearUpdateableData,
} = UpdateDayOfWeekSlicer.actions;

export default UpdateDayOfWeekSlicer.reducer;
